import { FC } from "react";
import { useTranslation } from "react-i18next";

import { errors, Log, RideSoftValidationErrorType } from "@ryde/shared";

import {
  RideSoftValidationErrorPriceRateChanged,
  RideSoftValidationErrorPriceRateChangedRideCancel,
} from "../components";
import { IRideSoftValidationErrorItemProps } from "../models";

const RideSoftValidationErrorFreezeTime: FC<
  IRideSoftValidationErrorItemProps & { freezeTimeKey: string }
> = ({ error, freezeTimeKey }) => {
  const { t } = useTranslation();

  return (
    <li>
      {t(freezeTimeKey, {
        maxDuration: error.additional?.maxDuration,
        newDuration: error.additional?.newDuration,
      })}
    </li>
  );
};

export const RideSoftValidationErrorItem: FC<
  IRideSoftValidationErrorItemProps
> = ({ error }) => {
  const { t } = useTranslation();

  switch (error.type) {
    case RideSoftValidationErrorType.PriceRateChangedRideCancel:
      return (
        <RideSoftValidationErrorPriceRateChangedRideCancel error={error} />
      );
    case RideSoftValidationErrorType.PriceRateChanged:
      return <RideSoftValidationErrorPriceRateChanged error={error} />;
    case RideSoftValidationErrorType.RideSwitchToDraft:
      return <li>{t(errors.ride.rideSwitchToDraft)}</li>;
    case RideSoftValidationErrorType.SupplierFreezeTimeToCreateRide:
      return (
        <RideSoftValidationErrorFreezeTime
          error={error}
          freezeTimeKey={errors.softValidation.freezeTimeToCreateRide}
        />
      );
    case RideSoftValidationErrorType.SupplierFreezeTimeToChangeRide:
      return (
        <RideSoftValidationErrorFreezeTime
          error={error}
          freezeTimeKey={errors.softValidation.freezeTimeToChangeRide}
        />
      );
    case RideSoftValidationErrorType.SupplierFreezeTimeToCancelRide:
      return (
        <RideSoftValidationErrorFreezeTime
          error={error}
          freezeTimeKey={errors.softValidation.freezeTimeToCancelRide}
        />
      );
    case RideSoftValidationErrorType.DoneRidePriceRecalculate:
      return (
        <li>
          {t(errors.softValidation.doneRidePriceRecalculate, error.additional)}
        </li>
      );
    default:
      Log.debug("Soft Validation Error type:", error.type);
      Log.debug("Soft Validation Error additional:", error.additional);
      Log.debug("Soft Validation Error message:", error.message);

      return (
        <li>
          {t(`validation.softValidation.${error.type}`, error.additional)}
        </li>
      );
  }
};
